module.exports = __webpack_public_path__ + "static/CCS-logo.c7973214.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/CCS-logo.png
// module id = 569
// module chunks = 35783957827783